import { Icon, Logo as LoomLogo, Spacer, SvgSearch } from '@loomhq/lens';
import React from 'react';

import { getCloudfrontURI } from 'utilities/avatar';
import { getCustomBrandLogo } from 'utilities/custom-branding';

import getItems from './items';
import DropMenu from './menu';

import HeaderPortalDestination from 'components/layout/header/portal-destination';

const Cta = props => (
  <a href={props.href}>
    <span className="gradient-text">{props.title}</span>
  </a>
);

const Link = ({ item, onClick }) => {
  const isActive = window.location.pathname.includes(item.href);
  const className = isActive ? 'is-active' : '';

  return (
    <a
      href={item.href}
      title={item.title}
      className={className}
      onClick={onClick}
    >
      {item.title}
    </a>
  );
};

const Jobs = ({ item }) => {
  const isActive = window.location.pathname.includes('careers');
  const className = isActive ? 'is-active' : '';

  return (
    <a href={item.href} title={item.title} className={className}>
      {item.title}
    </a>
  );
};

const Button = ({ item, onClick }) => {
  return (
    <a href={item.href} className="navigationBar__button" onClick={onClick}>
      {item.title}
    </a>
  );
};

export const Logo = props => {
  const { brand_logo: brandLogo } = props.companyFeatureData || {};
  let style =
    brandLogo && !props.userIsOwner
      ? { backgroundImage: `url(${getCloudfrontURI(brandLogo)})` }
      : null;

  if (getCustomBrandLogo()) {
    style = { backgroundImage: `url(${getCustomBrandLogo()})` };

    return (
      <a
        href={props.href}
        className="navigationBar__logo"
        onClick={props.onClick}
        style={style}
      >
        Loom.com
      </a>
    );
  }

  return (
    <a
      href={props.href}
      onClick={props.onClick}
      style={style}
      id="loggedOutSharePageLogo"
    >
      <LoomLogo maxWidth={12} />
    </a>
  );
};

const More = props => {
  const name = (props.item && props.item.name) || 'more';

  return (
    <React.Fragment>
      <a className="navigationBar__more" onClick={props.onMenuToggle(name)}>
        More
      </a>
      {
        <DropMenu
          className="contained"
          items={getItems(name)}
          stateProps={props}
          onClose={props.onMenuToggle(null)}
          open={props.menu === name}
        />
      }
    </React.Fragment>
  );
};

const Avatar = props => (
  <React.Fragment>
    <a onClick={props.onMenuToggle('account')}>
      &nbsp;
      <img src={props.avatar} className="navigationBar__avatar" />
    </a>
  </React.Fragment>
);
const SignOut = props => (
  <a onClick={props.onSignOut} className="alert">
    Sign out
  </a>
);

const WithCallBack = ({ item, onClick }) => (
  <a onClick={onClick}>{item.title}</a>
);

const Search = ({ onClick }) => (
  <div className="navigationBar__navItem__search" onClick={onClick}>
    <Icon icon={<SvgSearch />} />
    <Spacer left={1}>Search</Spacer>
  </div>
);

export const TYPES = {
  cta: Cta,
  link: Link,
  signout: SignOut,
  jobs: Jobs,
  button: Button,
  more: More,
  avatar: Avatar,
  help: WithCallBack,
  search: Search,
  portal: HeaderPortalDestination,
};

export default type => TYPES[type] || Link;
